/* Review form (sections/bumpology-review-form.liquid).
 * URL: /pages/review?t=<token>&rating=<n>
 * 1. GET {prefill}/<token>/ and a signed form token, in parallel.
 * 2. One card per product in the order; the first opens with ?rating= chosen.
 * 3. POST multipart to {submit}. Vanilla JS, no dependencies.
 */
(function () {
  var root = document.querySelector('[data-bump-review-form]');
  if (!root) return;

  var params = new URLSearchParams(location.search);
  var token = params.get('t') || '';
  var presetRating = parseInt(params.get('rating'), 10);
  var loading = root.querySelector('[data-rf-loading]');
  var invalid = root.querySelector('[data-rf-invalid]');
  var allDone = root.querySelector('[data-rf-all-done]');
  var container = root.querySelector('[data-rf-products]');
  var template = root.querySelector('[data-rf-template]');
  var formToken = '';
  var MAX_PHOTOS = 3;
  var MAX_BYTES = 8 * 1024 * 1024;
  var MAX_VIDEO_BYTES = 100 * 1024 * 1024;
  var EXT_MIME = { jpg: 'image/jpeg', jpeg: 'image/jpeg', png: 'image/png', webp: 'image/webp',
                   gif: 'image/gif', heic: 'image/heic', heif: 'image/heif',
                   mp4: 'video/mp4', mov: 'video/quicktime', m4v: 'video/x-m4v', webm: 'video/webm' };
  var VIDEO_TYPES = ['video/mp4', 'video/quicktime', 'video/x-m4v', 'video/webm'];

  // Chrome reports formats it can't decode (e.g. .heic) as application/octet-stream,
  // so fall back to the extension (same rule as the influencer upload page).
  function guessType(file) {
    if (file.type && file.type !== 'application/octet-stream') return file.type;
    var ext = (file.name.split('.').pop() || '').toLowerCase();
    return EXT_MIME[ext] || file.type || '';
  }

  /* Photo picker: tap (phones open the photo library / camera), click, or drag
     and drop. Keeps its own list so photos can be removed one by one. */
  function wirePhotos(node) {
    var zone = node.querySelector('[data-rf-drop]');
    var input = node.querySelector('[data-rf-files]');
    var thumbs = node.querySelector('[data-rf-thumbs]');
    var error = node.querySelector('[data-rf-error]');
    var picked = [];
    var seen = Object.create(null);

    function say(msg) { error.textContent = msg; error.hidden = !msg; }

    function render() {
      thumbs.textContent = '';
      picked.forEach(function (file, i) {
        var card = document.createElement('div');
        card.className = 'bump-rf__thumb';
        var type = guessType(file);
        if (type.indexOf('video/') === 0) {
          var vid = document.createElement('video');
          vid.muted = true; vid.playsInline = true; vid.preload = 'metadata';
          vid.src = URL.createObjectURL(file) + '#t=0.5';
          vid.onerror = function () { vid.remove(); };
          card.appendChild(vid);
          var tag = document.createElement('span');
          tag.className = 'bump-rf__thumb-tag';
          tag.textContent = 'Video';
          card.appendChild(tag);
        } else if (type === 'image/heic' || type === 'image/heif') {
          card.appendChild(document.createTextNode(file.name));  // most browsers can't preview HEIC
        } else {
          var img = document.createElement('img');
          img.alt = '';
          img.src = URL.createObjectURL(file);
          img.onerror = function () { img.remove(); card.insertBefore(document.createTextNode(file.name), card.firstChild); };
          card.appendChild(img);
        }
        var x = document.createElement('button');
        x.type = 'button';
        x.className = 'bump-rf__thumb-x';
        x.setAttribute('aria-label', 'Remove photo ' + (i + 1));
        x.textContent = '\u00d7';
        x.addEventListener('click', function (e) {
          e.stopPropagation();
          delete seen[file.name + '|' + file.size + '|' + file.lastModified];
          picked.splice(i, 1);
          render();
        });
        card.appendChild(x);
        thumbs.appendChild(card);
      });
      var nPhotos = picked.filter(function (f) { return guessType(f).indexOf('image/') === 0; }).length;
      zone.classList.toggle('is-full', nPhotos >= MAX_PHOTOS && picked.length - nPhotos >= 1);
    }

    function add(fileList) {
      var problems = [];
      Array.prototype.slice.call(fileList || []).forEach(function (file) {
        var key = file.name + '|' + file.size + '|' + file.lastModified;
        if (seen[key]) return;
        var type = guessType(file);
        var isVideo = type.indexOf('video/') === 0;
        var photos = picked.filter(function (f) { return guessType(f).indexOf('image/') === 0; }).length;
        var videos = picked.length - photos;
        if (isVideo) {
          if (VIDEO_TYPES.indexOf(type) === -1) { problems.push('"' + file.name + '": please use an MP4, MOV or WebM video.'); return; }
          if (videos >= 1) { problems.push('You can add one video.'); return; }
          if (file.size > MAX_VIDEO_BYTES) { problems.push('"' + file.name + '" is larger than 100 MB.'); return; }
        } else {
          if (type.indexOf('image/') !== 0) { problems.push('"' + file.name + '" is not a photo or video.'); return; }
          if (photos >= MAX_PHOTOS) { problems.push('You can add up to ' + MAX_PHOTOS + ' photos.'); return; }
          if (file.size > MAX_BYTES) { problems.push('"' + file.name + '" is larger than 8 MB.'); return; }
        }
        seen[key] = true;
        picked.push(file);
      });
      say(problems.filter(function (p, i, a) { return a.indexOf(p) === i; }).join(' '));
      render();
    }

    zone.addEventListener('click', function () { input.click(); });
    zone.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); input.click(); }
    });
    input.addEventListener('change', function () { add(input.files); input.value = ''; });
    zone.addEventListener('dragover', function (e) { e.preventDefault(); zone.classList.add('is-over'); });
    zone.addEventListener('dragleave', function () { zone.classList.remove('is-over'); });
    zone.addEventListener('drop', function (e) {
      e.preventDefault();
      zone.classList.remove('is-over');
      if (e.dataTransfer && e.dataTransfer.files) add(e.dataTransfer.files);
    });
    return {
      photos: function () { return picked.filter(function (f) { return guessType(f).indexOf('image/') === 0; }); },
      video: function () { return picked.filter(function (f) { return guessType(f).indexOf('video/') === 0; })[0] || null; }
    };
  }

  function show(el, on) { el.hidden = !on; }

  function fetchJSON(url, opts) {
    return fetch(url, opts).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (body) {
        return { ok: res.ok, status: res.status, body: body };
      });
    });
  }

  function refreshFormToken() {
    return fetchJSON(root.dataset.tokenUrl, { credentials: 'omit' }).then(function (r) {
      formToken = (r.body && r.body.token) || '';
    }).catch(function () { formToken = ''; });
  }

  function buildStars(fieldset, idx, initial) {
    var labels = [];
    function paint(value) {
      labels.forEach(function (l, i) { l.classList.toggle('is-on', i < value); });
    }
    for (var n = 1; n <= 5; n++) {
      var id = 'rf-' + idx + '-star-' + n;
      var input = document.createElement('input');
      input.type = 'radio'; input.name = 'rating'; input.value = String(n); input.id = id;
      if (n === initial) input.checked = true;
      var label = document.createElement('label');
      label.htmlFor = id;
      label.textContent = '★';
      label.setAttribute('aria-label', n + (n === 1 ? ' star' : ' stars'));
      (function (value) {
        input.addEventListener('change', function () { paint(value); });
        label.addEventListener('mouseenter', function () { paint(value); });
      })(n);
      fieldset.appendChild(input);
      fieldset.appendChild(label);
      labels.push(label);
    }
    fieldset.addEventListener('mouseleave', function () {
      var checked = fieldset.querySelector('input:checked');
      paint(checked ? parseInt(checked.value, 10) : 0);
    });
    paint(initial || 0);
  }

  function checkAllDone() {
    var open = container.querySelectorAll('[data-rf-card]:not([data-done])');
    if (!open.length) show(allDone, true);
  }

  function buildCard(product, idx, displayName, isFirst) {
    var node = template.content.firstElementChild.cloneNode(true);
    var img = node.querySelector('[data-rf-image]');
    if (product.image_url) { img.src = product.image_url; img.alt = product.title; img.hidden = false; }
    node.querySelector('[data-rf-title]').textContent = product.title;
    var body = node.querySelector('[data-rf-body]');

    if (product.reviewed) {
      node.setAttribute('data-done', '');
      show(node.querySelector('[data-rf-reviewed]'), true);
      show(body, false);
      return node;
    }

    buildStars(node.querySelector('[data-rf-stars]'), idx, isFirst && presetRating >= 1 && presetRating <= 5 ? presetRating : 0);
    node.querySelector('[name="display_name"]').value = displayName || '';


    node._photos = wirePhotos(node);

    if (!isFirst) {
      show(body, false);
      var toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'button button--secondary bump-rf__toggle';
      toggle.textContent = 'Review this too';
      toggle.addEventListener('click', function () { show(body, true); toggle.remove(); });
      node.querySelector('.bump-rf__product').after(toggle);
    }

    node.addEventListener('submit', function (e) {
      e.preventDefault();
      submitCard(node, product);
    });
    return node;
  }

  function submitCard(node, product) {
    var error = node.querySelector('[data-rf-error]');
    var button = node.querySelector('[data-rf-submit]');
    var rating = node.querySelector('[name="rating"]:checked');
    var body = node.querySelector('[name="body"]').value.trim();
    var files = node._photos ? node._photos.photos() : [];
    var video = node._photos ? node._photos.video() : null;
    var problems = [];
    if (!rating) problems.push('Please choose a star rating.');
    if (problems.length) { error.textContent = problems.join(' '); show(error, true); return; }
    show(error, false);

    var data = new FormData();
    data.append('token', token);
    data.append('product_id', product.product_id);
    data.append('rating', rating.value);
    data.append('title', node.querySelector('[name="title"]').value.trim());
    data.append('body', body);
    data.append('display_name', node.querySelector('[name="display_name"]').value.trim());
    data.append('hp', node.querySelector('[name="hp"]').value);
    data.append('form_token', formToken);
    files.slice(0, MAX_PHOTOS).forEach(function (f) { data.append('photos', f, f.name); });

    button.disabled = true;
    var original = button.textContent;
    var progress = node.querySelector('[data-rf-progress]');
    var bar = progress.querySelector('span');

    function finish() { button.disabled = false; button.textContent = original; progress.hidden = true; }
    function fail(msg) { error.textContent = msg; show(error, true); finish(); }

    // Phone videos are big, so in production they go straight to storage
    // (presigned S3 POST, same pattern as the influencer upload page); the
    // review then carries only the signed key.
    function uploadVideo() {
      if (!video) return Promise.resolve();
      button.textContent = 'Uploading video…';
      return fetchJSON(root.dataset.videoUrl, {
        method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token: token, filename: video.name, size: video.size, content_type: guessType(video) })
      }).then(function (r) {
        if (!r.ok || !r.body.ok) throw new Error((r.body && r.body.error) || 'Could not start the video upload.');
        if (r.body.mode !== 's3') { data.append('video', video, video.name); return; }
        return new Promise(function (resolve, reject) {
          var form = new FormData();
          Object.keys(r.body.fields).forEach(function (k) { form.append(k, r.body.fields[k]); });
          form.append('file', video);
          var xhr = new XMLHttpRequest();
          xhr.open('POST', r.body.url);
          progress.hidden = false;
          xhr.upload.onprogress = function (e) { if (e.lengthComputable) bar.style.width = Math.round(100 * e.loaded / e.total) + '%'; };
          xhr.onload = function () {
            if (xhr.status >= 200 && xhr.status < 300) {
              data.append('video_key', r.body.key);
              data.append('video_signature', r.body.signature);
              resolve();
            } else { reject(new Error('The video upload failed. Please try again.')); }
          };
          xhr.onerror = function () { reject(new Error('The video upload failed. Please check your connection.')); };
          xhr.send(form);
        });
      });
    }

    uploadVideo().then(function () {
      button.textContent = 'Sending…';
      return fetchJSON(root.dataset.submitUrl, { method: 'POST', body: data, credentials: 'omit' });
    }).then(function (r) {
      if (r.ok && r.body.ok) {
        show(node.querySelector('[data-rf-body]'), false);
        var toggle = node.querySelector('.bump-rf__toggle');
        if (toggle) toggle.remove();
        var msg = r.body.status === 'published' ? 'Published. Thank you!' : 'Thank you! We read every review before it goes live.';
        if (r.body.media_pending) msg += ' Your photos and video will appear once we\u2019ve had a look.';
        node.querySelector('[data-rf-success-text]').textContent = msg;
        show(node.querySelector('[data-rf-success]'), true);
        node.setAttribute('data-done', '');
        checkAllDone();
        refreshFormToken();
        finish();
        return;
      }
      if (r.status === 403) refreshFormToken();
      fail((r.body && r.body.error) || 'Something went wrong. Please try again.');
    }).catch(function (e) {
      fail(e && e.message ? e.message : 'We could not reach our server. Please check your connection and try again.');
    });
  }

  if (!token) { show(loading, false); show(invalid, true); return; }

  Promise.all([
    fetchJSON(root.dataset.prefillUrl + encodeURIComponent(token) + '/', { credentials: 'omit' }),
    refreshFormToken(),
  ]).then(function (results) {
    var r = results[0];
    show(loading, false);
    if (!r.ok || !r.body.ok || r.body.expired) { show(invalid, true); return; }
    var heading = root.querySelector('[data-rf-heading]');
    if (r.body.first_name) heading.textContent = 'How was your order, ' + r.body.first_name + '?';
    var firstOpen = (r.body.products || []).findIndex(function (p) { return !p.reviewed; });
    (r.body.products || []).forEach(function (p, i) {
      container.appendChild(buildCard(p, i, r.body.display_name, i === firstOpen));
    });
    checkAllDone();
  }).catch(function () { show(loading, false); show(invalid, true); });
})();
